import React from 'react';

export default function Toast({ message, type = 'default' }) {
  return (
    <div className={`toast toast--${type}`}>
      {message}
    </div>
  );
}
